import React from "react"
import Helmet from "react-helmet"
import Nav from "../../components/nav"
import Footer from "../../components/footer"
import Card from "../../components/dashboard-card"
import Row from "react-bootstrap/Row"
import Container from "react-bootstrap/Container"
import Col from "react-bootstrap/Col"
import Loader from "../../components/loader"
import avatar from "../../assets/default.png"
import Input from "../../components/dashboard-input"
import CardHeader from "../../components/dashboard-card-header"
import Guild from "../../components/guild"
import Changelog from "../../components/changelog"
import DashboardPill from "../../components/dashboard-pill"
import SweetAlert from "../../components/custom-sweetalert"
import MiniLoader from "../../components/mini-loader"
import "./index.css"

const BotView = (props) => {
  let bots = props.bots.map((bot, index) => (
    <option value={bot.id} key={`bot-${index}`}>
      {bot.name}
    </option>
  ))
  let changelogs = props.changeLog.map((log, index) =>
    log.type ? (
      <Changelog key={`log-${index}`} type={log.type}>
        {log.content ? log.content : ""}
      </Changelog>
    ) : (
      <span>{log}</span>
    )
  )
  let guilds = props.guilds.map((guild, index) => (
    <li key={`guild-${index}`}>
      <Guild guild={guild} />
    </li>
  ))
  return props.initializing ? (
    <React.Fragment>
      {!props.botError && <Loader />}
      {props.alert && <SweetAlert {...props.alert} />}
    </React.Fragment>
  ) : (
    <div className={"bots"}>
      <Helmet>Orders | {process.env.REACT_APP_NAME}</Helmet>
      <Nav logOut={props.logOut} user={props.user} />
      <Container className={"mt-5 pb-5"}>
        <Row>
          <Col
            md={{
              span: 10,
              offset: 1,
            }}
          >
            <Card>
              <CardHeader>Bots</CardHeader>
              <div className={"body"}>
                {props.ajaxLoading && <MiniLoader />}
                <Row className={"mt-4"}>
                  <Col md={3}>
                    <img
                      src={
                        props.botData.avatar
                          ? `https://cdn.discordapp.com/avatars/${props.botData.id}/${props.botData.avatar}.jpg`
                          : avatar
                      }
                      className={"avatar"}
                      alt={props.user.username}
                    />
                  </Col>
                  <Col md={9}>
                    <Input
                      type={"text"}
                      className={"w-100"}
                      select
                      placeholder={"Choose a bot"}
                      label={"Choose a bot"}
                      name={"chooseBot"}
                      required
                      fullWidth
                      onChange={props.updateBotInfo}
                      value={props.currentBot ? props.currentBot.id : ""}
                    >
                      {bots}
                    </Input>
                    <Row className={"mt-4"}>
                      <Col>
                        <p className={"mb-0"}>Bot Name:</p>
                        <p className={"valuep"}>
                          {props.currentBot ? props.currentBot.name : ""}
                        </p>
                      </Col>
                      <Col>
                        <p className={"mb-0"}>Bot Status:</p>
                        <p>
                          <DashboardPill
                            type={
                              props.currentBot.online ? "online" : "offline"
                            }
                          >
                            {props.currentBot.online ? "Online" : "Offline"}
                          </DashboardPill>
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className={"button-div mt-4"}>
                          <button
                            onClick={() => props.action("start")}
                            className={"start"}
                          >
                            Start
                          </button>
                          <button
                            onClick={() => props.action("stop")}
                            className={"stop"}
                          >
                            Stop
                          </button>
                          <button
                            onClick={() => props.action("kill")}
                            className={"kill"}
                          >
                            Kill
                          </button>
                          <button
                            onClick={() => props.action("restart")}
                            className={"restart"}
                          >
                            Restart
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col>
                    <h5>Guilds</h5>
                    <ul className={"guilds mt-3"}>{guilds}</ul>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className={"changelog"}>
                      <h4>Changelog</h4>
                      {changelogs}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <form className={"request-change"}>
                      <h5>Request Change</h5>
                      <div className={"mt-3"}>
                        <Input
                          type={"text"}
                          className={"w-100"}
                          placeholder={"Change"}
                          label={"Change"}
                          name={"changeRequest"}
                          value={props.changeRequest}
                          onChange={props.onInputChange}
                          required
                          fullWidth
                        />
                      </div>
                      <button
                        onClick={(e) =>
                          props.submitChangeMessage(e, props.changeRequest)
                        }
                      >
                        Request
                      </button>
                    </form>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer />
      {props.alert && <SweetAlert {...props.alert} />}
    </div>
  )
}
export default BotView



// WEBPACK FOOTER //
// ./src/routes/bot/BotView.js